<template>
  <ubi-panel>
    <ubi-list-header slot="header"
                     :limits="limits"
                     :total="results.total"
                     :page.sync="page"
                     :limit.sync="limit"
                     :sort.sync="sort"
                     :sortProperties="sortProperties"></ubi-list-header>
    <template slot="actions">
      <div v-if="!selected.length">
        <el-button icon="export" size="mini" @click="exporter">
          {{$t("general.selection.exportAll") }}
        </el-button>
        <el-button size="mini" @click="gestionAffichageReduit(true)" v-if="!affichageReduit">
          <em class="el-icon-s-fold"></em>
          {{$t("users.listMode") }}
        </el-button>
        <el-button size="mini" @click="gestionAffichageReduit(false)" v-if="affichageReduit">
          <em class="el-icon-menu"></em>
          {{$t("users.vignetteMode") }}
        </el-button>
      </div>
      <div v-else>
        <span class="inline">{{ $t("general.selection.forSelection") }} ({{ selected.length }}) :</span>
        <el-button-group class="inline">
          <el-button class="PostsList-export" size="mini" @click="exporter">{{ $t("general.selection.export")
            }}
          </el-button>
          <el-button class="PostsList-export" size="mini"
                     @click="$emit('modal-delete-list', {quantite: selected.length, selection: selected})"> {{ $t("posts.list.delete") }}
          </el-button>
          <el-button class="PostsList-export" size="mini"
                     v-if="annonceFlux === false"
                     @click="$emit('switch-published', selected)">{{ $t("general.selection.activateDeactivate") }}
          </el-button>
          <el-button class="PostsList-export" size="mini"
                     v-if="saisit_en_ligne"
                     @click="$emit('change-contacts', { selection: selected })">{{ $t("general.selection.changeContact") }}
          </el-button>
          <el-button class="PostsList-export" size="mini"
                     v-if="hasMultiAccounts"
                     @click="$emit('change-users', { selection: selected })">{{ $t("posts.list.assignUser") }}
          </el-button>
        </el-button-group>
      </div>
    </template>
    <ubi-list-footer
        slot="footer"
        v-if="results.total > 1"
        :limits="limits"
        :total="results.total"
        :page.sync="page"
        :limit.sync="limit"
        :sort.sync="sort"
        :sortProperties="sortProperties"
    ></ubi-list-footer>
    <el-table ref="table"
              :data="results.list"
              v-loading="loadingStatus"
              @select="selectedChanged"
              @select-all="selectAllChanged"
    >
      <el-table-column
          type="selection"
          width="55">
      </el-table-column>
      <el-table-column label="" width="100">
        <template v-slot="{ row: result }">
          <img width="80" v-if="result.photoPrincipale != null"
               alt=""
               :src="result.photoPrincipale.url_miniature"
               :srcset="result.photoPrincipale.url_miniature"
          />
          <div v-else style="text-align: center;">
            <ubi-icon class="no-photo" name="camera" size='60'/>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('components.lists.diffusee')">
        <template v-slot="{ row: result }">
          <div v-if="(result.nbDiffusions > 0) && (result.nbPortailsActifs > 0)">
            <div class="text-center"><em class="el-icon-success text-success mr-2" style="font-size: 1.9em;"></em></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Date création" width="100">
        <template v-slot="{ row: result }">
          {{result.dateCreation.substring(0,16)}}
        </template>
      </el-table-column>
      <el-table-column label="Référence" width="100">
        <template v-slot="{ row: result }">
          {{result.reference}}
        </template>
      </el-table-column>
      <el-table-column label="Titre" width="170">
        <template v-slot="{ row: result }">
          <div :span="12" v-if="result.titre.length>47">
            {{result.titre.substring(0,32)}} (...)
          </div>
          <div :span="12" v-if="result.titre.length<=47">
            {{ result.titre}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Prix" width="90">
        <template v-slot="{ row: result }">
          {{result.prix}}
        </template>
      </el-table-column>
      <el-table-column label="Contact(s)" width="90">
        <template v-slot="{ row: result }">
          <router-link
              :to="{ name: 'contacts-posts-detail', params: { post: result.reference}}"
              class="lienContactsListeAnnonces">
            <div class="text-center">{{result.nbContactsMailtracking}}</div>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column label="Activée" width="90">
        <template v-slot="{ row: result }">
          <div v-if="result.etatAnnonce == 'Active'" class="text-center">
            <em class="el-icon-success text-success mr-2" style="font-size: 1.9em;"></em></div>
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="center" min-width="90">
        <template v-slot="{ row: result }">
          <el-dropdown class="inline" @command="handleCommand">
            <el-button size="mini" icon="more" type="success"
                       @click.prevent.native=""></el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ name: 'switch-published', id: result.id }" v-if="saisieEnLigne">
                  {{ $t("general.selection.activateDeactivate") }}
                </el-dropdown-item>
              <router-link
                  :to="{ name: 'post-view', params: { post: result.id } }"
              >
                <a @click="eventAnalytics('fiche_produit')">
                  <el-dropdown-item
                      v-if="saisit_en_ligne && ((result.typeObjet < 3000 || result.typeObjet >= 4000) || possedeContactManager == false) && (!isSubUser || (isSubUser && result.etat !== 'M'))">
                    {{ $t("posts.card.details") }}
                  </el-dropdown-item>
                </a>
              </router-link>
              <router-link
                  v-if="saisit_en_ligne"
                  :to="{ name: 'post-edit', params: { id: result.id }, query: { saisie: result.sourceCode } }">
                <el-dropdown-item>
                  {{ $t("posts.card.edit") }}
                </el-dropdown-item>
              </router-link>
              <router-link v-if="result.etat != 'M' && result.etat != 'B'"
                           :to="{name :'portals-selection-post', params: { post : result.id }}">
                <el-dropdown-item>
                  {{ $t("posts.card.diffuse") }}
                </el-dropdown-item>
              </router-link>
              <div v-if="saisit_en_ligne && result.etat == 'M'">
                  <el-dropdown-item :command="{name: 'useModel', id: result.id}">
                    {{ $t("posts.card.useThisModel") }}
                  </el-dropdown-item>
              </div>
              <div v-if="saisit_en_ligne && result.etat != 'M'">
                  <el-dropdown-item :command="{name: 'duplicate', id: result.id}">
                    {{ $t("posts.card.duplicate") }}
                  </el-dropdown-item>
              </div>
              <div v-if="!result.donnees.date_debut_diffusion && result.etat !== 'M' && result.etat !== 'A'">
                <a @click="eventAnalytics('programmer_diffusion'); $emit('diffuse-later', {id:result.id, diffuseLaterDate:result.donnees.date_debut_diffusion})">
                  <el-dropdown-item>
                    {{ $t('posts.list.diffuseLater.planDiffusion') }}
                  </el-dropdown-item>
                </a>
              </div>
              <div v-if="result.donnees.date_debut_diffusion && result.donnees.date_debut_diffusion.valeur && result.etat !== 'M' && result.etat !== 'A'">
                <a @click="eventAnalytics('programmer_diffusion'); $emit('diffuse-later', {id:result.id, diffuseLaterDate:result.donnees.date_debut_diffusion})">
                  <el-dropdown-item>
                    {{ $t('posts.list.diffuseLater.reportDiffusion') }}
                  </el-dropdown-item>
                </a>
              </div>
              <div v-if="sitimmoUser.garantiePublication && result.etat != 'M'">
                <router-link
                    :to="{name :'attendance-report-post', params: { post : result.id }}">
                  <a @click="eventAnalytics('rapport_presence')">
                    <el-dropdown-item>
                      {{ $t("posts.card.presenceReport") }}
                    </el-dropdown-item>
                  </a>
                </router-link>
              </div>
              <div v-if="saisit_en_ligne && (!isSubUser || (isSubUser && result.etat !== 'M'))">
                  <el-dropdown-item :command="{name: 'delete', id: result.id}">
                    {{ $t("posts.list.delete") }}
                  </el-dropdown-item>
              </div>
              <router-link :to="{ name: 'private-note', params: { id: result.id }, query: { saisie: result.sourceCode } }" v-if="result.etat !== 'M'">
                <el-dropdown-item>
                  {{ $t("posts.card.privateNote") }}
                </el-dropdown-item>
              </router-link>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </ubi-panel>
</template>

<script>
import ElButton from '@/components/Button'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { exportXlsPosts } from '@/services/posts'
import {getFromSnake} from "@/helpers/functions/getFromSnake";

export default {
  name: 'TableListVo',
  components: {
    ElButton
  },
  props: ['affichageReduit', 'limits', 'total', 'sortProperties'],
  data () {
    return {
      referenceDuplication: null,
      selected: []
    }
  },
  computed: {
    ...mapState('postsVo', ['filter', 'loadingStatus', 'annonceFlux', 'saisieEnLigne', 'results']),
    ...mapGetters(['hasMultiAccounts', 'isMainAccount', 'isSubAdmin', 'isSubUser', 'getOfferTypes', 'getPickerOptionsShortcuts']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeContactManager () {
      return getFromSnake(this.sitimmoUser, 'possede_contact_manager')
    },
    saisit_en_ligne () {
      return (getFromSnake(this.sitimmoUser, 'saisit_annonces_en_ligne') || (getFromSnake(this.sitimmoUser, 'saisit_en_ligne_et_flux')))
    },
    packExpert () {
      return this.sitimmoUser.packDiffusion === 'pack_expert'
    },
    garantiePublication () {
      return this.sitimmoUser.garantiePublication === 'true'
    },
    nbStocks () {
      return this.sitimmoUser.stocks.length
    },
    stocks () {
      return this.sitimmoUser.stocks
    },
    saveFilters () {
      return this.$store.state.saveFilters
    },
    userFilter () {
      return this.filter.user
    },
    page: {
      get () {
        return this.filter.page
      },
      set (value) {
        this.setPage(value)
        this.$store.dispatch('postsVo/loadPosts')
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.$store.dispatch('postsVo/loadPosts')
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      async set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.filter.page = 1
        this.$emit('load-data')
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduire: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 47)
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduireRef: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 15)
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    loadingStatus: function () {
      this.selected = []
    }
  },
  methods: {
    ...mapMutations('postsVo', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setOffset',
      'setLimit',
      'setResults',
      'resetFilter',
      'setObjectType',
      'setLoadingStatus',
      'setCurrentId',
      'setModalDuplicate',
      'setModalDelete',
      'setModalUseModel'
    ]),
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.sitimmoUser.id)
    },
    async doSelect (type) {
      if (type === '*') {
        const tmpSelection = this.results.list.map(({ id }) => id)
        this.selected = this.selected.concat(tmpSelection)
      }
      if (type === null) {
        const tmpSelection = this.results.list.map(({ id }) => id)
        this.selected = []
      }
    },
    async exporter () {
      this.setLoadingStatus(true)
      let i = 0
      let strSelectedIds = null
      this.selected.forEach(function (idSelected) {
        if (i === 0) {
          strSelectedIds = idSelected
        } else {
          strSelectedIds = strSelectedIds + ',' + idSelected
        }
        i++
      })

      const res = await exportXlsPosts(this.filter, strSelectedIds, false, this.$t('posts.list.filenameExportAds'))
      this.$message(res)
      this.setLoadingStatus(false)
    },
    handleCommand (command) {
      if (command.name === 'delete') {
        this.setCurrentId(command.id)
        this.setModalDelete(true)
      } else if (command.name === 'useModel') {
        this.setCurrentId(command.id)
        this.setModalUseModel(true)
      } else if (command.name === 'switch-published') {
        this.$emit('switch-published', command.id)
      } else if (command.name === 'duplicate') {
        this.setCurrentId(command.id)
        this.setModalDuplicate(true)
        // this.$emit('open-duplicate-modal', command.id)
      } else if (command.name === 'edit') {
        this.$router.push({
          name: 'post-edit',
          params: { id: command.id },
          query: { saisie: command.sourceCode }
        })
      } else if (command.name === 'attendanceReport') {
        this.eventAnalytics('rapport_presence')
        this.$router.push({ name: 'attendance-report-post', params: { post: command.id } })
      } else if (command.name === 'diffuseLater') {
        this.eventAnalytics('programmer_diffusion')
        this.$emit('diffuse-later', { id: command.id, diffuseLaterDate: command.diffuseLaterDate })
      } else if (command.name === 'private-note') {
        this.$router.push({
          name: 'private-note',
          params: { id: command.id },
          query: { saisie: command.sourceCode }
        })
      }
    },
    gestionAffichageReduit (rep) {
      this.$emit('affichage-reduit', rep)
    },
    selectAllChanged (selection) {
      this.selected = []
      // unselect all case
      if (!selection.length) {
        const self = this
        this.results.list.forEach(function (item) {
          const index = self.selected.indexOf(item.id)
          if (index > -1) {
            this.selected.splice(index, 1)
          }
        }, self)
        // this.$refs.tablePortalsList.clearSelection();
      } else if (selection.length === 0) {
        this.selected = []
      }
      else { // select all case
        this.doSelect('*')
      }
    },
    selectedChanged (selection, row) {
      let add = false
      selection.forEach(function (item) {
        if (item.id === row.id) {
          add = true
        }
      })

      const index = this.selected.indexOf(row.id)

      if (add) {
        if (index === -1) {
          this.selected.push(row.id)
        }
      } else {
        if (index > -1) {
          this.selected.splice(index, 1)
        }
      }
    }
  }

}
</script>
